import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    // Moved your custom loading state here
    return (
      <>
        {/* Make sure ambientStyle and grainStyle are imported/defined here */}
        <div style={{ /* ambientStyle */ }} />
        <div style={{ /* grainStyle */ }} />
        <div style={{
          position: 'relative', zIndex: 1,
          height: '100dvh',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <style>{`@keyframes pulse{0%,100%{opacity:.3}50%{opacity:1}}`}</style>
          <div style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'var(--text-xs)',
            letterSpacing: '0.3em',
            color: 'var(--gold-dim)',
            textTransform: 'uppercase',
            animation: 'pulse 2s ease-in-out infinite',
          }}>
            Entering stillness...
          </div>
        </div>
      </>
    );
  }

  // If there's a user, render the wrapped component. Otherwise, kick them to auth.
  return user ? children : <Navigate to="/auth" replace />;
}